import { useEffect, useState } from "react";
import { _DocumentFactory, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_LG, MODAL_SM, MODAL_XL } from "../../../../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { Modal } from "../../../../../../theme/Component/Modal";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { YearSelector } from "../../../../../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../../../../../contract/select/SelectMonths";
import { AccountEditor } from "../../../../../../editor/AccountEditor";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { ErrorList } from "../../../../../../theme/Component/ErrorList";
import { DocumentViewer } from "../../../../../../theme/Component/DocumentViewer";
import { BasicPage } from "../../../../../../theme/Component/BasicPage";
import { SelectProject } from "../../../../../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import usePaginator from "../../../../../../theme/Component/usePaginator";
import { ParentDocument } from "../../ublsalesaccountantdocument/UBLInvoiceFactory/ParentDocument";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";

interface Props {
    onChange: any;
    label?: string;
    isMenu?: boolean;
    onChangeProyect?: Function;
}

interface FormProps {
    Year: number;
    Mnemonic: string;
    Month?: number;
    IDAccount?: number;
    Consecutive?: number;
}

export const InventoryRemissionFactory = ({ onChange, label, isMenu, onChangeProyect }: Props) => {

    const { instance, lista, bean, setBean, setLista } = useDataBean(_DocumentFactory);
    const doc = useDataBean(_DocumentFactory)
    const [renderValue, setRenderValue] = useState<string>("");
    const [form, setForm] = useState<FormProps>({
        Mnemonic: "IFR",
        Year: _single.getCurrenYear(),
    })
    const modal = useModal("Seleccione una Remision de Producto", MODAL_LG);
    const modalDoc = useModal("Documento Contable", MODAL_XL);
    const modalAsociate = useModal("Asociar Documento Contable", MODAL_XL);
    const modalDisasociate = useModal("Liberar Documento de Cruce", MODAL_SM);

    const paginador = usePaginator();


    useEffect(() => {
        if (form.Year && form.Mnemonic) {
            getLista();
        } else {
            // toast.error("Campos Obligatorios: Vigencia y Proyecto")
        }
    }, [paginador.page])

    const getLista = () => {
        instance.getDocumentHeaderByMnemonic(form.Year, form.Month, form.IDAccount, form.Mnemonic, form.Consecutive, paginador.page, 15).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                if (resp.List) {
                    resp.List.forEach(element => {
                        const document = element.DataBeanProperties;
                        document.RenderDocumento = `${document.Consecutive ? `${document.Mnemonic} - ${document.Consecutive}` : "N/A"}`;
                        document.RenderFactura = `${document.ParentConsecutive ? `${document.ParentMnemonic} - ${document.ParentConsecutive}` : "N/A"}`;
                    });
                }
                setLista(resp.List);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'Documento Remisión', property: 'RenderDocumento', visible: true },
        { title: 'Identificación', property: 'AccountNit', visible: true },
        { title: 'Tercero', property: 'AccountName', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Estado', property: 'DocumentStateName', visible: true },
        { title: 'Factura', property: 'RenderFactura', visible: true },
        { title: 'Fecha Factura', property: 'ParentDate', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Documento', icono: 'ri-eye-line', visible: bean.IDDocument, evento: () => { getDocument(bean.IDDocument, bean.DocumentDate) } },
            { titulo: 'Ver Documento de Cruce', icono: 'ri-eye-line', visible: bean.ParentIDDocument, evento: () => { getDocument(bean.ParentIDDocument, bean.ParentDate) } },
            { titulo: 'Asociar Documento de Cruce', icono: 'ri-add-line', visible: true, evento: () => { modalAsociate.open(); setSelectDoc({}) } },
            { titulo: 'Liberar Documento de Cruce', icono: 'ri-subtract-line', visible: bean.ParentIDDocument, evento: () => { modalDisasociate.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const getDocument = (idDocument: number, docDate: any) => {
        instance.getAccountantDocumentByLocation(idDocument, docDate).then(
            (resp) => {
                doc.setLista(resp.DocumentURL)
                modalDoc.open()
                setMsgList(resp.MsgList);
            }
        ).catch(err => { toast.error(err) })
    }

    const selectItem = () => {
        if (bean.IDDocument) {
            setRenderValue(`${bean.RenderDocumento}`)
            modal.close();
            onChange?.(bean)
        } else {
            toast.error("Orden no valida")
        }
    }

    const [selectDoc, setSelectDoc] = useState<any>({});

    const asingParentDocument = () => {
        instance.setParentDocument(bean.IDDocument, bean.DocumentDate, selectDoc.IDDocument, selectDoc.Since).then(
            (resp) => {
                getLista();
                modalAsociate.close();
            }
        ).catch(
            err => { toast.error(err) }
        )
    }


    const disasociate = () => {
        instance.releaseParentDocument(bean.IDDocument, bean.DocumentDate).then(
            (resp) => {
                getLista();
                modalDisasociate.close();
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const [documents, setDocuments] = useState<any>([]);
    const [msgList, setMsgList] = useState<any>([]);

    const returnComponente = () => {
        return (
            <div className="row">
                <div className="col-md-6">
                    <YearSelector onChange={(e) => { setForm({ ...form, Year: e }) }} value={form.Year} tittle="Vigencia" />
                </div>
                <div className="col-md-6">
                    <SelectMonths idSelector={form.Month} onChange={(e) => { setForm({ ...form, Month: e }) }} label="Mes" />
                </div>
                <div className="col-md-6">
                    <AccountEditor idAccount={form.IDAccount} label="Tercero" onChange={(e) => { setForm({ ...form, IDAccount: e.IDAccount }) }} />
                </div>
                <div className="col-md-6">
                    <label>Consecutivo</label>
                    <input type="number" className="form-control" value={form.Consecutive} onChange={(e) => {
                        const value = e.target.value ? Number(e.target.value) : null;
                        setForm({ ...form, Consecutive: value })
                    }} />
                </div>
                {/* <div className="col-md-6">
                    <SelectProject label="Proyecto" idSelector={form.IDProject} onChange={(e: any) => {
                        setForm({ ...form, IDProject: e?.IDProject });
                        onChangeProyect?.(e);
                    }} returnType="Object" />
                </div> */}
                <div className="col-md-6 mt-4">
                    <BasicButton eventClick={() => {
                        if (form.Year && form.Mnemonic) {
                            getLista();
                        }
                    }} icon="ri-search-line" children={`Buscar`} />
                </div>
                <div className="col-md-12">
                    <BasicTable
                        listButtons={listaBotones()}
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                    />
                </div>

                <div className="col-md-12">
                    <Modal modal={modalDoc.modal} updateModal={modalDoc.setModal} >
                        <div className="row">
                            <div className="col">
                                {msgList.length > 0 &&
                                    <ErrorList lista={msgList} />
                                }
                                {msgList.length === 0 && lista.length > 0 &&
                                    <DocumentViewer key={doc.lista} list={doc.lista} />
                                }
                            </div>
                        </div>
                    </Modal>
                </div>

                <div className="col-md-12">
                    <ModalConfirm eventModal={disasociate} modal={modalDisasociate.modal} updateModal={modalDisasociate.setModal} >
                        ¿Desea liberar el Documento Asociado?
                    </ModalConfirm>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalAsociate.modal} updateModal={modalAsociate.setModal} eventModal={() => {
                        if (selectDoc.IDDocument) {
                            asingParentDocument()
                        } else {
                            toast.error("Documento no Valido")
                        }
                    }} >
                        <ParentDocument onChange={(e) => { setSelectDoc(e) }} />
                    </Modal>
                </div>
            </div>
        )
    }


    return isMenu ? (
        <BasicPage children={returnComponente()} titulo="Remisiones de Producto" />
    ) : (
        <>
            <label>{label ? label : 'Remisión de Producto'}</label>
            <input
                type="text"
                className="form-control"
                placeholder="Buscar..."
                value={renderValue}
                onClick={() => { modal.open() }}
            />

            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { selectItem() }}>
                {returnComponente()}
            </Modal>
        </>
    )

}